export const components = {
  'to {{email}}': 'para {{email}}',
  'to {{phone}}': 'para {{phone}}',
  'Your data is protected': 'Seus dados estão protegidos',
  'We use security best practices to keep your information safe':
    'Utilizamos as melhores práticas de segurança para manter suas informações protegidas',
  'Your data is masked': 'Seus dados estão mascarados',
  'For security reasons, we only show part of your registered information':
    'Por motivos de segurança, mostramos apenas parte das suas informações cadastradas.',

  'Doubts?': 'Dúvidas?',

  'Here is some important information about password recovery':
    'Aqui estão algumas informações importantes sobre a recuperação de senha',

  'Go to login': 'Ir para login',

  'No one at Vialaser will have access to your new password':
    'Ninguém da Vialaser terá acesso à sua nova senha',

  'Valid code': 'Código válido',
  'The verification code is valid for {{time}} minutes':
    'O código de verificação é válido por {{time}} minutos',

  "Don't share your code": 'Não compartilhe seu código',
  'Never share your verification code with third parties':
    'Nunca compartilhe seu código de verificação com terceiros',

  'Need help?': 'Precisa de ajuda?',
  'Contact our support team': 'Entre em contato com nossa equipe de suporte',
};
